import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

const INTERVAL = 3000
const MAX_CHECKS = 20

// While Claude writes a saved walk's note, check every few seconds; once it's ready, reload the page so
// the walk shows its new name and note. Gives up quietly after a minute.
export default class extends Controller {
  static values = { url: String }

  connect() {
    this.checks = 0
    this.schedule()
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  schedule() {
    this.timer = setTimeout(() => this.check(), INTERVAL)
  }

  async check() {
    this.checks++
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
      const { note } = await response.json()
      if (note) return Turbo.visit(window.location.href, { action: "replace" })
    } catch (error) {
      // Try again on the next check
    }

    if (this.checks < MAX_CHECKS) this.schedule()
    else this.element.remove()
  }
}
